import React, { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    const onScroll = () => {
      const el = document.getElementById("first-cta");
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-32" data-mp="38b8m23nkkgmu">
      {visible && <motion.div initial={{
      y: 120,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 120,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 bg-navy-950/90 p-3 backdrop-blur sm:inset-x-auto sm:bottom-5 sm:right-5 sm:bg-transparent sm:p-0 sm:backdrop-blur-none" data-id="element-33" data-mp="38d1w7sxe5izl">
          <motion.a href={CHECKOUT_URL} animate={reduceMotion ? undefined : {
        x: [0, -7, 7, -6, 6, -3, 3, 0],
        rotate: [0, -1.5, 1.5, -1, 1, 0, 0, 0]
      }} transition={{
        duration: 0.45,
        repeat: Infinity,
        repeatDelay: 1.2,
        ease: "easeInOut"
      }} className="flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-4 font-display text-xl font-extrabold uppercase tracking-wide text-cta-ink shadow-[0_6px_0_0_#b98200] focus:outline-none focus-visible:ring-4 focus-visible:ring-electric-light sm:w-auto sm:px-7" data-id="element-34" data-mp="2pbw66a543j58">
            <ShoppingCartIcon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-35" data-mp="9kqdnymwzb5f" />
            <span className="whitespace-nowrap" data-id="element-36" data-mp="9inqdmd5bw4e">Get It Now — $27</span>
            <span className="whitespace-nowrap text-base font-bold text-cta-ink/60 line-through" data-id="element-37" data-mp="77wkwm0kjb7j">$180</span>
          </motion.a>
        </motion.div>}
    </AnimatePresence>;
}